export default __webpack_public_path__ + "0a6bdda07d766c278c51d9d0eccb4ce0.jpg";